import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../../components/Table";
import ProductItem from "./ProductItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {LIST_SHOP_PRODUCTS, ON_NEW_SHOP_PRODUCT, ON_UPDATED_SHOP_PRODUCT, ON_UPDATED_SHOP_PRODUCTS} from "../../../queries/inventory";
import update from "immutability-helper";

function getItemKey(item) {
  return composeId(item.get("shopId"), item.get("productSku"));
}

function composeId(shopId, productSku) {
  return `${shopId}-${productSku}`;
}

class ProductsList extends Component {

  UNSAFE_componentWillMount() {
    this.unsubscribeToNewProducts = this.props.subscribeToNewProducts(this.props, {}); 
    this.unsubscribeToProductUpdates = this.props.subscribeToProductUpdates(this.props, {}); 
    this.unsubscribeToAllProductUpdates = this.props.subscribeToAllProductUpdates(this.props, {}); 
  }

  componentWillUnmount() {
    if (this.unsubscribeToNewProducts) {
      this.unsubscribeToNewProducts();
    }
    if (this.unsubscribeToProductUpdates) {
      this.unsubscribeToProductUpdates();
    }
    if (this.unsubscribeToAllProductUpdates) {
      this.unsubscribeToAllProductUpdates();
    }
  }

  render() {
    let {loading, error, shopProducts} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />

    let tableHeader = List([
      "SKU",
      "Title",
      "Price"
    ])

    return (
      <React.Fragment>
        <h5>Product Pricing</h5>
        <Table 
          data={fromJS(shopProducts)} 
          renderer={ProductItem} 
          mode="table"
          tableHeader={tableHeader}
          onItemClick={this.handleItemClick.bind(this)}
          selected={composeId(this.props.shopId, this.props.selectedProductId)}
          getItemKey={getItemKey}
          />
      </React.Fragment>
    )
  }

  handleItemClick(itemData, e) {
    let id = itemData.get("productSku");
    this.props.onSelectionChange(id, itemData.get("shopId"));
  }  
}


const mapDispatchToProps = dispatch => ({
  subscribeToNewProducts: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_NEW_SHOP_PRODUCT,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return update(prev, {
          shopProducts: {
            $push: [subscriptionData.data.newShopProduct]
          }
        })
      }
    })
  },
  subscribeToProductUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_SHOP_PRODUCT,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return prev;
        }
        return {
          shopProduct: subscriptionData.data.updatedShopProduct
        }
      }
    })
  },
  subscribeToAllProductUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_SHOP_PRODUCTS,
      variables: {
        shopId: props.shopId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }  
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(LIST_SHOP_PRODUCTS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      shopId: props.shopId
    }    
  })
})

export default withQuery(withSubscription(ProductsList));